import {Label} from '@radix-ui/react-label';
import clsx from 'clsx';

type Props = React.ComponentPropsWithRef<typeof Label> & {required?: boolean};
export const SelectLabel = ({
  ref: forwardedRef,
  className,
  ...props
}: Props & {
  ref?: React.RefObject<HTMLLabelElement>;
}) => {
  return (
    <Label
      {...props}
      ref={forwardedRef}
      className={clsx('mb-2 block text-sm/6 font-medium', className)}
    >
      {props.required && <span className="mr-1 text-tomato11">&#42;</span>}
      {props.children}
    </Label>
  );
};

SelectLabel.displayName = 'SelectLabel';
